/* ==========================================================================
   gba-gift-finder.js  —  Gift Finder · Dawn-native rebuild
   --------------------------------------------------------------------------
   Pure vanilla JS · No dependencies · defer-loaded
   Dawn cart: POST /cart/add.js → renderContents() → open cart drawer
   ========================================================================== */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════════════════
     ICONS  — keyed by option val
     ════════════════════════════════════════════════════════════════════════ */
  var ICONS = {
    /* ── Occasion ──────────────────────────────────────────────────────── */
    'Any Occasions': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><g clip-path="url(#a1)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.113 5.988c.055 0 .11 0 .165 0 .037.026.072.057.105.094.075.175.157.347.245.516.193.05.388.084.586.105.181.053.232.167.152.34-.14.14-.281.281-.422.422.007.213.034.424.082.633-.026.145-.112.212-.258.199-.2-.082-.391-.18-.574-.293-.203.111-.41.213-.621.305-.136-.02-.207-.097-.211-.234.035-.203.063-.406.082-.609-.15-.153-.301-.301-.455-.445 0-.07 0-.14 0-.21.034-.023.065-.05.093-.082.22-.037.438-.076.657-.117.093-.174.183-.35.27-.527.032-.037.067-.068.105-.094zM7.184 6.69c.053.102.115.2.187.293.116.038.233.069.352.094-.09.058-.164.133-.223.222-.004.127-.008.252-.011.375-.092-.056-.19-.095-.293-.117-.118.024-.228.071-.328.14.018-.124.025-.249.023-.375-.065-.089-.14-.171-.223-.246.116-.029.233-.06.352-.094.063-.093.118-.19.164-.293z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.254 5.988c.094 0 .188 0 .281 0 .22.113.303.293.246.539-.164.284-.387.343-.668.176-.188-.211-.188-.422 0-.633.045-.034.092-.062.141-.082z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.879 5.988c.07 0 .14 0 .21 0 .11.127.146.276.106.446-.066.161-.179.204-.34.129-.028-.022-.047-.049-.059-.082-.015-.133-.015-.266 0-.399.032-.028.06-.058.083-.094z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.316 6.573c.136-.008.269.004.399.035.124.143.109.268-.047.375-.125.016-.25.016-.375 0-.161-.147-.153-.284.023-.41z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.324 6.574c.137-.012.27.004.398.047.08.092.091.193.036.304-.021.028-.049.048-.082.059-.144.021-.284.013-.422-.024-.066-.078-.086-.168-.059-.27.032-.052.075-.091.129-.116z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.926 6.972c.149-.02.238.043.269.188.027.137.007.266-.059.386-.133.09-.246.07-.34-.058-.016-.133-.016-.266 0-.399.032-.052.075-.092.13-.117z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.559 7.184c.101-.016.19.008.269.07.274 1.148.219 2.281-.164 3.398-.144.362-.293.721-.457 1.079-.124.097-.242.089-.351-.024-.015-.038-.026-.078-.035-.118.175-.434.342-.872.504-1.312.282-.951.318-1.912.105-2.882-.003-.096.037-.166.129-.211z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.035 7.583c.452-.04.71.163.774.609-.041.373-.248.576-.621.609-.373-.033-.58-.236-.621-.609.025-.306.181-.509.468-.609zM12.129 8.005c.218.01.284.111.199.304-.119.098-.22.083-.305-.047-.038-.119.015-.205.106-.257z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.512 8.169c.383-.004.766 0 1.148.012.042.018.077.046.106.082.038.396.046.795.023 1.196-.018.042-.046.077-.082.106-.396.038-.792.046-1.195.023-.042-.018-.077-.046-.106-.082-.038-.396-.046-.794-.023-1.195.031-.059.074-.106.129-.142zM13.793 8.591h.586v.586h-.586v-.586z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.699 8.776c.146-.027.244.028.293.164.016.101.016.203 0 .305-.016.059-.051.102-.106.128-.07.016-.14.016-.21 0-.037-.029-.064-.064-.082-.106-.016-.125-.016-.25 0-.375.022-.049.057-.088.105-.116z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.293 17.987c-.063 0-.125 0-.188 0-.047-.031-.086-.07-.117-.117 0-.07 0-.14 0-.21.136-.529.273-1.06.41-1.594.102-.11.216-.122.34-.035.035.048.051.103.047.164-.092.41-.186.821-.28 1.231.539-.197 1.078-.396 1.617-.598-.557-.5-.896-1.121-1.02-1.863-.044-.453-.087-.906-.127-1.36.015-.174.109-.249.281-.222.06.016.103.051.129.106.047.468.094.937.14 1.405.133.706.473 1.288 1.02 1.746.769-.267 1.535-.548 2.298-.855-1.887-.963-3.02-2.49-3.398-4.582.03-.175.132-.242.304-.199.051.02.086.055.106.106.395 2.127 1.587 3.611 3.574 4.453.461-.176.922-.352 1.383-.527-.59-.232-1.137-.537-1.641-.914-1.228-.931-2.201-2.076-2.918-3.434-.196-.392-.274-.806-.234-1.242.068-.295.244-.494.527-.598.17-.035.342-.043.515-.023.167.107.182.232.047.375-.13.029-.262.044-.398.047-.112.031-.194.097-.246.199-.062.342-.016.67.141.984.398.804.906 1.531 1.523 2.18.717.773 1.541 1.402 2.473 1.886.324.167.668.245 1.031.235.217-.067.318-.215.305-.445-.024-.246-.078-.484-.164-.715.025-.163.119-.229.281-.199.057.018.1.053.129.106.17.387.209.786.117 1.196-.082.207-.227.351-.44.433-2.53.946-5.053 1.903-7.57 2.871z" fill="white"/></g><defs><clipPath id="a1"><rect width="12" height="12" fill="white" transform="translate(6 6)"/></clipPath></defs></svg>',
    'Christmas' : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"></rect><path d="M12 5.8l2.1 3.5h-1.4l2.1 3.3h-1.4l2.1 3.4H8.5l2.1-3.4H9.2l2.1-3.3H9.9L12 5.8z" fill="white"></path><rect x="11.25" y="15.9" width="1.5" height="2.1" fill="white"></rect><circle cx="12" cy="6.4" r="0.9" fill="white"></circle></svg>',
    'winter': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><path d="M12 6v12M9 8l3-2 3 2M9 16l3 2 3-2M8 12l-2-1M18 12l-2-1M8 12l-2 1M18 12l-2 1M10 10l2 2 2-2M10 14l2-2 2 2" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    'Birthday': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><rect x="7" y="12" width="10" height="6" rx="1" stroke="white" stroke-width="1.3"/><path d="M9 12V11M12 12V10M15 12V11" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',

    'Celebration': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><path d="M7 17l4-9 2 5 2-3 2 4" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    'Anniversary': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><path d="M12 17s-5-3.5-5-7a3 3 0 015-2.2A3 3 0 0117 10c0 3.5-5 7-5 7z" stroke="white" stroke-width="1.3" stroke-linejoin="round"/></svg>',

    'Baby Shower': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="12" cy="10" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8.5 17.5c0-2 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',

    'Spa & Pamper': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><path d="M12 8c-2 2-3 4-3 6a3 3 0 006 0c0-2-1-4-3-6z" stroke="white" stroke-width="1.3" stroke-linejoin="round"/></svg>',

    /* ── Gender / Recipient ─────────────────────────────────────────── */
    'Any': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="9.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><circle cx="14.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><path d="M6 17c0-2 1.567-3.5 3.5-3.5S13 15 13 17" stroke="white" stroke-width="1.3" stroke-linecap="round"/><path d="M13 15c.4-.33.9-.5 1.5-.5C16.433 14.5 18 16.067 18 18" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',

    'For Him': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="12" cy="10" r="3" stroke="white" stroke-width="1.4"/><path d="M7 19c0-2.761 2.239-5 5-5s5 2.239 5 5" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',

    'For Her': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="12" cy="9.5" r="3" stroke="white" stroke-width="1.4"/><path d="M12 12.5v4M10 15h4" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',

    'For Kids': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="12" cy="9" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8 18c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',

    'For Baby': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><circle cx="12" cy="10" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8.5 17.5c0-2 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',

    'Corporate': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333333"/><rect x="7" y="11" width="10" height="7" rx="1.5" fill="white" opacity="0.92"/><rect x="6.5" y="9" width="11" height="3" rx="1.2" fill="white"/><path d="M10.5 9C9.3 9 8.7 8.2 8.7 7.5 8.7 6.8 9.2 6.3 9.9 6.3c.8 0 1.4.7 2.1 1.7.7-1 1.3-1.7 2.1-1.7.7 0 1.2.5 1.2 1.2C15.3 8.2 14.7 9 13.5 9h-3z" fill="white"/></svg>',

    /* ── Budget ─────────────────────────────────────────────────────── */
    '0to100': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="7" font-family="sans-serif" font-weight="bold">&lt;$100</text></svg>',
    '100to125': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$100-125</text></svg>',
    '125to150': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$125-150</text></svg>',
    '150to175': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$150-175</text></svg>',
    '175to200': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$175-200</text></svg>',
    'over200': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="8" font-family="sans-serif" font-weight="bold">$200+</text></svg>',
    'notsure': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15.5" text-anchor="middle" fill="white" font-size="12" font-family="sans-serif" font-weight="bold">?</text></svg>',

    /* ── Alcohol ─────────────────────────────────────────────────────── */
    'yes': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><path d="M8 12l3 3 5-5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'no': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><path d="M8 8l8 8M16 8l-8 8" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>',
    'dontmind': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#333"/><path d="M8 12h8" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };

  /* ════════════════════════════════════════════════════════════════════════
     CONFIGURATION — tag-based filtering
     ════════════════════════════════════════════════════════════════════════ */

  var TAG_MAP = {
    occasion: {
      'Any Occasions': [],
      'Christmas':['christmas-gift-baskets'],
      'Birthday': ['birthday-gift-baskets'],
      'Celebration': ['congratulations-gift-baskets'],
      'Anniversary': ['anniversary-gift-baskets'],
      'Baby Shower': ['baby-shower-gift-baskets'],
      'Spa & Pamper': ['spa-pamper-baskets'],
      'winter': ['winter-gift-baskets']
    },
    gender: {
      'Any': [],
      'For Him': ['GIFT BASKET FOR HIM', 'for him', 'him'],
      'For Her': ['GIFT BASKET FOR HER', 'for her', 'her'],
      'For Kids': ['for kids', 'kids'],
      'For Baby': ['BABY GIFT BASKETS', 'for baby', 'baby'],
      'Corporate': ['CORPORATE GIFT BASKETS', 'corporate', 'corporate gift']
    }
  };

  /* Occasion options — order matters for display */
  var OCCASION_OPTIONS = [
    { val: 'Any Occasions', label: 'Any Occasion' },
     { val: 'Christmas', label: 'Christmas' },
    { val: 'Birthday', label: 'Birthday' },
    { val: 'Celebration', label: 'Celebration' },
    { val: 'Anniversary', label: 'Anniversary' },
    { val: 'Baby Shower', label: 'Baby Shower' },
    { val: 'Spa & Pamper', label: 'Spa & Pamper' }
    
  ];

  /* Recipient options */
  var GENDER_OPTIONS = [
    { val: 'Any', label: 'Anyone' },
    { val: 'For Him', label: 'For Him' },
    { val: 'For Her', label: 'For Her' },
    { val: 'For Kids', label: 'For Kids' },
    { val: 'For Baby', label: 'For Baby' },
    { val: 'Corporate', label: 'Corporate' }
  ];

  /* Budget options */
  var BUDGET_OPTIONS = [
    { val: '0to100', label: 'Under $100', min: 0, max: 99.99 },
    { val: '100to125', label: '$100 – $125', min: 100, max: 124.99 },
    { val: '125to150', label: '$125 – $150', min: 125, max: 149.99 },
    { val: '150to175', label: '$150 – $175', min: 150, max: 174.99 },
    { val: '175to200', label: '$175 – $200', min: 175, max: 199.99 },
    { val: 'over200', label: 'Over $200', min: 200, max: 999999 },
    { val: 'notsure', label: 'Not Sure', min: 0, max: 999999 }
  ];

  /* Alcohol options */
  var ALCOHOL_OPTIONS = [
    { val: 'dontmind', label: "Don't Mind" },
    { val: 'yes', label: 'With Alcohol' },
    { val: 'no', label: 'Alcohol Free' }
  ];

  /* Tags that indicate alcohol content */
  var ALCOHOL_TAGS = ['ALCOHOL GIFT BASKETS', 'alcohol', 'with alcohol', 'wine', 'beer', 'spirits', 'champagne', 'alcoholic'];
  var ALCOHOLFREE_TAGS = ['alcohol free', 'alcohol-free', 'non-alcoholic', 'non alcoholic'];

  /* Tags that should be hidden entirely */
  var HIDDEN_TAGS = [
    'import gba', 'box_builder', 'easify box builder', 'searchanise_ignore',
    'personalize', 'general-bundles', 'extras products', 'cyo-personalise',
    'cyo-snacks', 'cards', 'cyo-beverage', 'basket designs', 'extras', 'extranew',
    'extra bundles', 'extra', 'content 18', 'cyo sweets'
  ];

  /* Source collection — broad collection that holds all products */
  var SOURCE_COLLECTION = 'gift-hampers';  /* ← change to your main collection handle */
  var MAX_FETCH = 200;
  var PER_PAGE = 4;

  /* ════════════════════════════════════════════════════════════════════════
     STATE
     ════════════════════════════════════════════════════════════════════════ */
  var sel = { occasion: null, gender: null, budget: null, alcohol: null };
  var allProducts = [];
  var currentPage = 1;

  /* Product caches keyed by collection handle */
  var productCache   = null;   /* SOURCE_COLLECTION (broad) */
  var occasionCache  = {};     /* handle → products[] for each occasion */
  var currentOccasionProducts = null; /* products for the currently active occasion */

  /* ════════════════════════════════════════════════════════════════════════
     DOM REFS
     ════════════════════════════════════════════════════════════════════════ */
  var $ = function (id) { return document.getElementById(id); };
  var DOM = {};

  function resolveDOM() {
    DOM.caseOccasion = $('gba-cs-occasion');
    DOM.caseRecipient = $('gba-cs-recipient');
    DOM.caseBeverage = $('gba-cs-beverage');
    DOM.caseBudget = $('gba-cs-budget');
    DOM.trigOccasion = $('gba-trig-occasion');
    DOM.trigRecipient = $('gba-trig-recipient');
    DOM.trigBeverage = $('gba-trig-beverage');
    DOM.trigBudget = $('gba-trig-budget');
    DOM.lblOccasion = $('gba-lbl-occasion');
    DOM.lblRecipient = $('gba-lbl-recipient');
    DOM.lblBeverage = $('gba-lbl-beverage');
    DOM.lblBudget = $('gba-lbl-budget');
    DOM.dropOccasion = $('gba-drop-occasion');
    DOM.dropRecipient = $('gba-drop-recipient');
    DOM.dropBeverage = $('gba-drop-beverage');
    DOM.dropBudget = $('gba-drop-budget');
    DOM.btnFind = $('gba-btn-find');
    DOM.loading = $('gba-gf-loading');
    DOM.results = $('gba-gf-results');
    DOM.resultsTitle = $('gba-gf-results-title');
    DOM.resultsSub = DOM.results && DOM.results.querySelector('.gba-gf__results-sub');
    DOM.grid = $('gba-gf-grid');
    DOM.empty = $('gba-gf-empty');
    DOM.pages = $('gba-gf-pages');
    DOM.restart = $('gba-gf-restart');
    DOM.body    = $('gba-gf-body');
    DOM.qv = null; DOM.qvClose = null; DOM.qvBody = null; /* QV removed */
  }

  /* ════════════════════════════════════════════════════════════════════════
     DROPDOWN HELPERS
     ════════════════════════════════════════════════════════════════════════ */

  /* Build option HTML with icon */
  function optionHTML(item) {
    var icon = ICONS[item.val] ? '<span class="gba-opt__icon" aria-hidden="true">' + ICONS[item.val] + '</span>' : '';
    var check = '<svg class="gba-opt__check" width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7l4 4 6-7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return (
      '<li class="gba-opt" role="option" data-val="' + escAttr(item.val) + '" aria-selected="false" tabindex="0">' +
      icon +
      '<span class="gba-opt__text">' + escHtml(item.label) + '</span>' +
      check +
      '</li>'
    );
  }

  function renderOpts(ulEl, items) {
    ulEl.innerHTML = items.map(optionHTML).join('');
  }

  function openDrop(csEl, trigEl) {
    closeAllDrops(csEl);
    csEl.classList.add('gba-open');
    trigEl.setAttribute('aria-expanded', 'true');
  }
  function closeDrop(csEl, trigEl) {
    csEl.classList.remove('gba-open');
    if (trigEl) trigEl.setAttribute('aria-expanded', 'false');
  }

  function closeAllDrops(except) {
    [DOM.caseOccasion, DOM.caseRecipient, DOM.caseBeverage, DOM.caseBudget].forEach(function (cs) {
      if (cs && cs !== except && cs.classList.contains('gba-open')) {
        closeDrop(cs, cs.querySelector('.gba-trig'));
      }
    });
  }

  /* Wire one combobox step */
  function wireStep(csEl, trigEl, dropEl, lblEl, items, selKey, onPick) {
    renderOpts(dropEl, items);

    trigEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (csEl.classList.contains('gba-off')) return;
      csEl.classList.contains('gba-open') ? closeDrop(csEl, trigEl) : openDrop(csEl, trigEl);
    });

    dropEl.addEventListener('click', function (e) {
      var opt = e.target.closest('.gba-opt');
      if (!opt || opt.classList.contains('gba-dim')) return;
      var val = opt.dataset.val;
      var item = items.find(function (i) { return i.val === val; });
      if (!item) return;

      Array.from(dropEl.querySelectorAll('.gba-opt')).forEach(function (o) {
        o.classList.toggle('gba-sel', o.dataset.val === val);
        o.setAttribute('aria-selected', o.dataset.val === val ? 'true' : 'false');
      });

      lblEl.textContent = item.label;
      lblEl.classList.add('is-set');
      sel[selKey] = val;

      closeDrop(csEl, trigEl);
      onPick(item);
    });

    dropEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var opt = e.target.closest('.gba-opt');
        if (opt) { e.preventDefault(); opt.click(); }
      } else if (e.key === 'Escape') {
        closeDrop(csEl, trigEl);
        trigEl.focus();
      }
    });
  }

  function enableStep(csEl, trigEl) {
    csEl.classList.remove('gba-off');
    if (trigEl) { trigEl.removeAttribute('disabled'); trigEl.removeAttribute('tabindex'); }
  }

  /* ════════════════════════════════════════════════════════════════════════
     PRODUCT FETCHING
     ════════════════════════════════════════════════════════════════════════ */


  /** Return the collection handle for an occasion value, or null for 'Any Occasions'. */
  function getOccasionHandle(occasionVal) {
    if (!occasionVal || occasionVal === 'Any Occasions') return null;
    var handles = TAG_MAP.occasion[occasionVal] || [];
    return handles[0] || null;
  }

  /** Fetch the broad SOURCE_COLLECTION. Returns Promise<products[]>. */
  function fetchProducts() {
    if (productCache) return Promise.resolve(productCache);
    var limit = Math.min(MAX_FETCH, 250);
    var url = '/collections/' + SOURCE_COLLECTION + '/products.json?limit=' + limit;
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache = (data && data.products) ? data.products : [];
        return productCache;
      })
      .catch(function (e) {
        return [];
      });
  }

  /** Fetch products for a specific occasion and call callback(products[]). */
  function fetchOccasionProducts(occasionVal, callback) {
    var handle = getOccasionHandle(occasionVal);

    /* ── 'Any Occasions' — merge products from ALL known occasion collections ── */
    if (!handle) {
      var allHandles = Object.keys(TAG_MAP.occasion)
        .filter(function (k) { return k !== 'Any Occasions'; })
        .map(function (k) { return TAG_MAP.occasion[k][0]; })
        .filter(Boolean);

      if (!allHandles.length) {
        /* Fallback: no specific occasions defined, use SOURCE_COLLECTION */
        fetchProducts().then(function (products) {
          currentOccasionProducts = products;
          callback(products);
        });
        return;
      }

      /* Fetch every occasion collection then deduplicate by product id */
      var limit = Math.min(MAX_FETCH, 250);
      var fetches = allHandles.map(function (h) {
        if (occasionCache[h]) return Promise.resolve(occasionCache[h]);
        return fetch('/collections/' + h + '/products.json?limit=' + limit)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data && data.products) ? data.products : [];
            occasionCache[h] = prods;
            return prods;
          })
          .catch(function () { return []; });
      });

      Promise.all(fetches).then(function (arrays) {
        var seen = {};
        var merged = [];
        arrays.forEach(function (arr) {
          arr.forEach(function (p) {
            if (!seen[p.id]) { seen[p.id] = true; merged.push(p); }
          });
        });
        currentOccasionProducts = merged;
        callback(merged);
      });
      return;
    }

    /* ── Specific occasion — use cached or fetch ── */
    if (occasionCache[handle]) {
      currentOccasionProducts = occasionCache[handle];
      callback(occasionCache[handle]);
      return;
    }

    var limit = Math.min(MAX_FETCH, 250);
    var url = '/collections/' + handle + '/products.json?limit=' + limit;

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) ? data.products : [];
        occasionCache[handle] = products;
        currentOccasionProducts = products;
        callback(products);
      })
      .catch(function (e) {
        currentOccasionProducts = [];
        callback([]);
      });
  }

  /* ════════════════════════════════════════════════════════════════════════
     FILTERING
     ════════════════════════════════════════════════════════════════════════ */

  function tagsOf(product) {
    return (product.tags || []).map(function (t) { return t.toLowerCase().trim(); });
  }

  function hasTag(tags, needles) {
    return needles.some(function (n) {
      var nl = n.toLowerCase().trim();
      return tags.some(function (t) { return t === nl || t.includes(nl); });
    });
  }

  function matchGender(product) {
    var g = sel.gender;
    if (!g || g === 'Any') return true;
    var needed = TAG_MAP.gender[g] || [];
    if (!needed.length) return true;
    return hasTag(tagsOf(product), needed);
  }

  function matchBudget(product) {
    var b = sel.budget;
    if (!b || b === 'notsure') return true;
    var opt = BUDGET_OPTIONS.find(function (o) { return o.val === b; });
    if (!opt) return true;
    var price = parseFloat((product.variants && product.variants[0]) ? product.variants[0].price : (product.price || 0));
    return price >= opt.min && price <= opt.max;
  }

  function matchAlcohol(product) {
    var a = sel.alcohol;
    if (!a || a === 'dontmind') return true;
    var tags = tagsOf(product);
    if (a === 'yes') return hasTag(tags, ALCOHOL_TAGS);
    if (a === 'no') return hasTag(tags, ALCOHOLFREE_TAGS) || !hasTag(tags, ALCOHOL_TAGS);
    return true;
  }

  function isHidden(product) {
    return hasTag(tagsOf(product), HIDDEN_TAGS);
  }

  /* ── Smart option availability ────────────────────────────────────────────
     Count how many products in the CURRENT OCCASION POOL match a candidate
     option. No occasion tag-check here: the pool is already scoped to the
     right collection via fetchOccasionProducts.
  ─────────────────────────────────────────────────────────────────────────── */
  function countWithSel(testSel) {
    var pool = currentOccasionProducts || productCache;
    if (!pool) return 1; /* nothing cached yet — don't dim anything */

    return pool.filter(function (p) {
      if (p.available === false) return false;
      if (isHidden(p)) return false;

      /* Gender */
      var g = testSel.gender;
      if (g && g !== 'Any') {
        var gTags = TAG_MAP.gender[g] || [];
        if (gTags.length && !hasTag(tagsOf(p), gTags)) return false;
      }

      /* Budget */
      var b = testSel.budget;
      if (b && b !== 'notsure') {
        var bOpt = BUDGET_OPTIONS.find(function (o) { return o.val === b; });
        if (bOpt) {
          var price = parseFloat((p.variants && p.variants[0]) ? p.variants[0].price : (p.price || 0));
          if (price < bOpt.min || price > bOpt.max) return false;
        }
      }

      /* Alcohol */
      var a = testSel.alcohol;
      if (a && a !== 'dontmind') {
        var ptags = tagsOf(p);
        if (a === 'yes' && !hasTag(ptags, ALCOHOL_TAGS)) return false;
        if (a === 'no'  && hasTag(ptags, ALCOHOL_TAGS))  return false;
      }

      return true;
    }).length;
  }

  /* Dim / enable options based on whether they yield results in the current pool */
  function dimUnavailableOpts(dropEl, selKey, items) {
    var pool = currentOccasionProducts || productCache;
    if (!pool) {
      return;
    }
    var opts = dropEl.querySelectorAll('.gba-opt');
    opts.forEach(function (optEl) {
      var val = optEl.dataset.val;
      var testSel = {
        occasion: sel.occasion,
        gender:   sel.gender,
        budget:   sel.budget,
        alcohol:  sel.alcohol
      };
      testSel[selKey] = val;
      var count = countWithSel(testSel);
      if (count === 0) {
        optEl.classList.add('gba-dim');
        optEl.setAttribute('aria-disabled', 'true');
        optEl.removeAttribute('tabindex');
      } else {
        optEl.classList.remove('gba-dim');
        optEl.removeAttribute('aria-disabled');
        optEl.setAttribute('tabindex', '0');
      }
    });
  }


  /* ════════════════════════════════════════════════════════════════════════
     SEARCH
     ════════════════════════════════════════════════════════════════════════ */

  function runSearch() {
    showLoading(true);
    hideResults();


    /* Use the already-fetched occasion pool if available; otherwise fall back
       to the broad SOURCE_COLLECTION. The occasion pool IS already scoped to
       the right collection, so we only need gender/budget/alcohol filters. */
    var doFilter = function (products) {
      allProducts = products.filter(function (p) {
        if (p.available === false) return false;
        if (isHidden(p)) return false;
        if (!matchGender(p)) return false;
        if (!matchBudget(p)) return false;
        if (!matchAlcohol(p)) return false;
        return true;
      });
      currentPage = 1;
      showLoading(false);
      renderResults();
    };

    if (currentOccasionProducts) {
      /* Pool already in memory from the occasion fetch */
      doFilter(currentOccasionProducts);
    } else {
      /* No specific occasion selected or cache not ready — use broad collection */
      fetchProducts()
        .then(function (products) {
          currentOccasionProducts = products;
          doFilter(products);
        })
        .catch(function (err) {
          showLoading(false);
          allProducts = [];
          renderResults();
        });
    }
  }

  /* ════════════════════════════════════════════════════════════════════════
     RENDER
     ════════════════════════════════════════════════════════════════════════ */

  function renderResults() {
    var total = allProducts.length;
    var start = (currentPage - 1) * PER_PAGE;
    var page = allProducts.slice(start, start + PER_PAGE);

    DOM.results.hidden = false;
    DOM.resultsTitle.textContent = total
      ? 'We found ' + total + ' gift' + (total !== 1 ? 's' : '') + ' for you!'
      : 'No gifts matched your selection';

    DOM.empty.hidden = total > 0;
    DOM.grid.hidden = total === 0;

    if (!total) { DOM.pages.innerHTML = ''; return; }

    DOM.grid.innerHTML = page.map(renderCard).join('');

    DOM.grid.querySelectorAll('.gba-gf__atc').forEach(function (btn) {
      if (btn.tagName === 'BUTTON') {
        btn.addEventListener('click', function () { handleATC(btn); });
      }
    });

    renderPages(total);

    requestAnimationFrame(function () {
      DOM.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function renderCard(p, idx) {
    var variant = (p.variants && p.variants[0]) ? p.variants[0] : {};
    var variantId = variant.id || '';
    var price = formatPriceDollars(variant.price || p.price || 0);
    var img = (p.images && p.images[0]) ? p.images[0].src.replace(/(\.[^.]+)$/, '_600x600$1') : '';
    var url = '/products/' + p.handle;
    var delay = (idx % PER_PAGE) * 0.04;
    var available = variant.available !== false;

    var hasVariants = false;
    if (p.variants && p.variants.length > 1) {
      hasVariants = true;
    } else if (p.options && p.options.length > 0) {
      if (!(p.options.length === 1 && (p.options[0].name === 'Title' || (p.options[0].values && p.options[0].values[0] === 'Default Title')))) {
        hasVariants = true;
      }
    }

    var buttonHtml = '';
    if (hasVariants) {
      buttonHtml =
        '<a class="gba-gf__atc gba-gf__atc--choose" href="' + escAttr(url) + '">' +
        '<span class="gba-gf__atc-txt">Choose Option</span>' +
        '</a>';
    } else {
      buttonHtml =
        '<button class="gba-gf__atc" type="button"' +
        ' data-variant-id="' + escAttr(String(variantId)) + '"' +
        ' data-handle="' + escAttr(p.handle) + '"' +
        (!available ? ' disabled' : '') + '>' +
        '<span class="gba-gf__atc-spin"></span>' +
        '<span class="gba-gf__atc-txt">' + (available ? 'Add to Cart' : 'Sold Out') + '</span>' +
        '</button>';
    }

    return (
      '<div class="gba-gf__card" role="listitem" style="animation-delay:' + delay + 's">' +
      '<div class="gba-gf__card-img-wrap">' +
      '<a href="' + escAttr(url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img class="gba-gf__card-img" src="' + escAttr(img) + '" alt="' + escAttr(p.title) + '" loading="lazy" width="300" height="300">' : '<div class="gba-gf__card-img" style="background:#f0ece5;"></div>') +
      '</a>' +
      '</div>' +
      '<div class="gba-gf__card-info">' +
      '<h3 class="gba-gf__card-title"><a href="' + escAttr(url) + '">' + escHtml(p.title) + '</a></h3>' +
      '<p class="gba-gf__card-price">' + price + '</p>' +
      '</div>' +
      '<div class="gba-gf__card-footer">' +
      buttonHtml +
      '</div>' +
      '</div>'
    );
  }

  function renderPages(total) {
    var totalPages = Math.ceil(total / PER_PAGE);
    if (totalPages <= 1) { DOM.pages.innerHTML = ''; return; }
    var html = '';
    if (currentPage > 1)
      html += '<button class="gba-gf__pg" data-pg="' + (currentPage - 1) + '" aria-label="Previous">←</button>';
    for (var i = 1; i <= totalPages; i++)
      html += '<button class="gba-gf__pg' + (i === currentPage ? ' is-on' : '') + '" data-pg="' + i + '" aria-label="Page ' + i + '">' + i + '</button>';
    if (currentPage < totalPages)
      html += '<button class="gba-gf__pg" data-pg="' + (currentPage + 1) + '" aria-label="Next">→</button>';
    DOM.pages.innerHTML = html;
  }

  /* ════════════════════════════════════════════════════════════════════════
     ADD TO CART  — Dawn-native (mirrors product-form.js exactly)
     ════════════════════════════════════════════════════════════════════════ */

  function handleATC(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    /* cart-drawer takes priority; fall back to cart-notification */
    var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    /* Append the section IDs that Dawn needs to re-render the cart HTML.
       This is what makes renderContents() work — without these the
       response.sections object will be empty and nothing updates. */
    if (cartEl && cartEl.getSectionsToRender) {
      formData.append(
        'sections',
        cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);

      /* Tell the drawer/notification which element triggered the add
         (so focus is returned correctly on close — matches product-form.js line 41) */
      if (typeof cartEl.setActiveElement === 'function') {
        cartEl.setActiveElement(btn);
      }
    }

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      /* Accept: application/javascript is REQUIRED — it tells Shopify to return
         rendered section HTML in response.sections so renderContents() can
         inject it and open the drawer. This matches fetchConfig('javascript')
         in Dawn's global.js (line 306) used by product-form.js (line 30). */
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status && response.status !== 200) {
          alert(response.description || response.message || 'Could not add to cart.');
          btn.classList.remove('is-loading');
          btn.disabled = false;
          return;
        }

        /* renderContents re-renders the cart HTML AND calls open() internally.
           This is the only call needed — no separate open() required.
           (cart-drawer.js line 94 / cart-notification.js line 76) */
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(response);
        }

        /* Remove is-empty class if cart was empty (matches product-form.js finally block) */
        if (cartEl && cartEl.classList.contains('is-empty')) {
          cartEl.classList.remove('is-empty');
        }

        /* Broadcast pub-sub so cart badge icon re-renders
           (matches product-form.js line 80) */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gba-gift-finder',
            productVariantId: String(variantId),
            cartData: response
          });
        }

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.querySelector('.gba-gf__atc-txt').textContent = '✓ Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.querySelector('.gba-gf__atc-txt').textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2400);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }


  /* ════════════════════════════════════════════════════════════════════════
     UTILITIES
     ════════════════════════════════════════════════════════════════════════ */


  function showLoading(show) {
    /* Reveal the whole results panel the moment a search begins */
    if (show && DOM.body) DOM.body.hidden = false;
    DOM.loading.hidden = !show;
  }

  function hideResults() {
    DOM.results.hidden = true;
    DOM.grid.innerHTML = '';
    DOM.pages.innerHTML = '';
  }

  function syncFindBtn() {
    DOM.btnFind.disabled = !sel.alcohol;  /* last required step */
  }

  function reset() {
    sel = { occasion: null, gender: null, budget: null, alcohol: null };
    allProducts = [];
    currentPage = 1;
    currentOccasionProducts = null; /* clear occasion pool so stale products don’t linger */

    [
      { lbl: DOM.lblOccasion, def: 'Any Type' },
      { lbl: DOM.lblRecipient, def: 'Recipient' },
      { lbl: DOM.lblBeverage, def: 'Budget' },
      { lbl: DOM.lblBudget, def: 'Alcohol' }
    ].forEach(function (x) {
      if (x.lbl) { x.lbl.textContent = x.def; x.lbl.classList.remove('is-set'); }
    });

    [DOM.dropOccasion, DOM.dropRecipient, DOM.dropBeverage, DOM.dropBudget].forEach(function (d) {
      if (d) d.querySelectorAll('.gba-opt').forEach(function (o) {
        o.classList.remove('gba-sel');
        o.setAttribute('aria-selected', 'false');
      });
    });

    [DOM.caseRecipient, DOM.caseBeverage, DOM.caseBudget].forEach(function (cs) {
      if (cs) cs.classList.add('gba-off');
    });
    [DOM.trigRecipient, DOM.trigBeverage, DOM.trigBudget].forEach(function (t) {
      if (t) { t.setAttribute('disabled', ''); t.setAttribute('tabindex', '-1'); }
    });

    document.querySelectorAll('[data-step]').forEach(function (s) { s.removeAttribute('data-picked'); });

    hideResults();
    showLoading(false);
    if (DOM.body) DOM.body.hidden = true; /* hide panel again after Start Over */
    syncFindBtn();

    requestAnimationFrame(function () {
      var bar = document.querySelector('.gba-gf__bar');
      if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }



  function formatPriceDollars(val) {
    if (val == null) return '';
    var n = parseFloat(val);
    return isNaN(n) ? '' : '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }

  /* ════════════════════════════════════════════════════════════════════════
     BOOT
     ════════════════════════════════════════════════════════════════════════ */

  function init() {
    resolveDOM();
    if (!DOM.caseOccasion) return;

    /* Step 1 — Occasion */
    wireStep(DOM.caseOccasion, DOM.trigOccasion, DOM.dropOccasion, DOM.lblOccasion,
      OCCASION_OPTIONS, 'occasion',
      function (item) {
        sel.occasion = item.val;
        document.querySelector('[data-step="occasion"]').setAttribute('data-picked', '');
        enableStep(DOM.caseRecipient, DOM.trigRecipient);
        syncFindBtn();

        /* Reset the occasion pool so stale data doesn’t carry over */
        currentOccasionProducts = null;


        /* Fetch the occasion-specific collection, then dim gender options that
           have no matching products. Until the fetch resolves, gender is fully
           enabled (nothing dimmed) — no blocking UX. */
        fetchOccasionProducts(item.val, function (products) {
          dimUnavailableOpts(DOM.dropRecipient, 'gender', GENDER_OPTIONS);
        });
      });

    /* Step 2 — Recipient / Gender */
    wireStep(DOM.caseRecipient, DOM.trigRecipient, DOM.dropRecipient, DOM.lblRecipient,
      GENDER_OPTIONS, 'gender',
      function (item) {
        sel.gender = item.val;
        document.querySelector('[data-step="recipient"]').setAttribute('data-picked', '');
        enableStep(DOM.caseBeverage, DOM.trigBeverage);
        /* Dim budget options that have 0 results with occasion+gender */
        dimUnavailableOpts(DOM.dropBeverage, 'budget', BUDGET_OPTIONS);
        syncFindBtn();
      });

    /* Step 3 — Budget */
    wireStep(DOM.caseBeverage, DOM.trigBeverage, DOM.dropBeverage, DOM.lblBeverage,
      BUDGET_OPTIONS, 'budget',
      function (item) {
        sel.budget = item.val;
        document.querySelector('[data-step="beverage"]').setAttribute('data-picked', '');
        enableStep(DOM.caseBudget, DOM.trigBudget);
        /* Dim alcohol options that have 0 results with occasion+gender+budget */
        dimUnavailableOpts(DOM.dropBudget, 'alcohol', ALCOHOL_OPTIONS);
        syncFindBtn();
      });

    /* Step 4 — Alcohol */
    wireStep(DOM.caseBudget, DOM.trigBudget, DOM.dropBudget, DOM.lblBudget,
      ALCOHOL_OPTIONS, 'alcohol',
      function (item) {
        sel.alcohol = item.val;
        document.querySelector('[data-step="budget"]').setAttribute('data-picked', '');
        syncFindBtn();
      });

    /* Find button */
    DOM.btnFind.addEventListener('click', function () { if (!DOM.btnFind.disabled) runSearch(); });

    /* Pagination */
    DOM.pages.addEventListener('click', function (e) {
      var btn = e.target.closest('.gba-gf__pg');
      if (!btn || btn.disabled || btn.classList.contains('is-on')) return;
      currentPage = parseInt(btn.dataset.pg, 10);
      renderResults();
      DOM.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Restart */
    DOM.restart.addEventListener('click', reset);

    /* Close dropdowns on outside click */
    document.addEventListener('click', function () { closeAllDrops(null); });

    /* Prefetch broad SOURCE_COLLECTION during browser idle time so the
       ‘Any Occasions’ path is instant. Zero paint-blocking impact. */
    var prefetch = function () {
      fetchProducts();
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(prefetch, { timeout: 4000 });
    } else {
      setTimeout(prefetch, 2000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[id^="gba-gf-"]')) init();
  });

})();
